import { useState } from 'react';
import { Lightbulb } from 'lucide-react';
import './HDRISelector.css';

const HDRI_PRESETS = [
    { value: 'warehouse', label: 'Warehouse', icon: '🏭' },
    { value: 'studio', label: 'Studio', icon: '🎬' },
    { value: 'city', label: 'City', icon: '🏙️' },
    { value: 'sunset', label: 'Sunset', icon: '🌅' },
    { value: 'park', label: 'Park', icon: '🌳' },
    { value: 'apartment', label: 'Apartment', icon: '🏠' },
    { value: 'lobby', label: 'Lobby', icon: '🏨' },
    { value: 'night', label: 'Night', icon: '🌙' },
    { value: 'forest', label: 'Forest', icon: '🌲' },
];

const BG_COLORS = [
    { value: '#E5E7EB', label: 'Light Gray' },
    { value: '#9CA3AF', label: 'Gray' },
    { value: '#374151', label: 'Dark Gray' },
    { value: '#000000', label: 'Black' },
    { value: '#FFFFFF', label: 'White' },
];

interface HDRISelectorProps {
    onPresetChange: (preset: string) => void;
    currentPreset: string;
    onBackgroundChange?: (color: string) => void;
    currentBackground?: string;
}

export default function HDRISelector({ onPresetChange, currentPreset, onBackgroundChange, currentBackground }: HDRISelectorProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="hdri-selector">
            <button
                className={`toolbar-btn ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                title="Change Lighting Preset"
            >
                <Lightbulb size={20} />
            </button>

            {isOpen && (
                <>
                    <div className="hdri-selector-backdrop" onClick={() => setIsOpen(false)} />
                    <div className="hdri-selector-dropdown">
                        <div className="hdri-selector-header">
                            <span>Environment Preset</span>
                            <button onClick={() => setIsOpen(false)}>×</button>
                        </div>
                        <div className="hdri-selector-list">
                            {HDRI_PRESETS.map((preset) => (
                                <button
                                    key={preset.value}
                                    className={`hdri-preset-option ${currentPreset === preset.value ? 'active' : ''}`}
                                    onClick={() => {
                                        onPresetChange(preset.value);
                                        setIsOpen(false);
                                    }}
                                >
                                    <span className="hdri-icon">{preset.icon}</span>
                                    <span className="hdri-label">{preset.label}</span>
                                </button>
                            ))}
                        </div>

                        {onBackgroundChange && (
                            <>
                                <div className="hdri-selector-divider"></div>
                                <div className="hdri-selector-header" style={{ paddingTop: '8px', borderBottom: 'none' }}>
                                    <span style={{ fontSize: '13px' }}>Background Color</span>
                                </div>
                                <div className="hdri-bg-options">
                                    {BG_COLORS.map(bg => (
                                        <button
                                            key={bg.value}
                                            className={`hdri-bg-swatch ${currentBackground === bg.value ? 'active' : ''}`}
                                            style={{ backgroundColor: bg.value }}
                                            title={bg.label}
                                            onClick={() => {
                                                onBackgroundChange(bg.value);
                                                // Optional: don't close so they can try multiple
                                            }}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}
